import React, { FC, useEffect, useMemo, useState } from 'react';
import './RowsManager.css';
import GeneralInput from '../../../main/components/generalInput/GeneralInput';
import { useForm } from 'react-hook-form';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { toast } from 'react-toastify';
import axiosInstance from '../../../main/initializers/axios';
import { ApiConstants } from '../../../main/constants/ApiConstants';
import IRow from '../../../main/interfaces/IRow';
import { useTranslation } from 'react-i18next';

interface Props {
  isOrder: boolean;
  handleClick?: () => void;
  header: string;
  rowType: number;
}

const RowsManager: FC<Props> = (props: Props) => {
  const { isOrder, header, handleClick, rowType } = props;

  const [rows, setRows] = useState<IRow[]>([]);

  const { i18n } = useTranslation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IRow>({
    defaultValues: { code: '', name: '' },
  });

  const fetchRows = () => {
    axiosInstance.get(`${ApiConstants.row.list}?rowType=${rowType}`).then((res) => {
      setRows(res.data ?? []);
    });
  };

  useEffect(() => {
    fetchRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowType]);

  const onSubmit = (data: IRow) => {
    const params = { name: data.name, code: data.code, type: rowType };

    axiosInstance.post(ApiConstants.row.update, params).then((response) => {
      if (response.status === 200) {
        toast.success(i18n.t('orderDetails.createdSuccessfully'));
        fetchRows();
        handleClick?.();
      } else {
        toast.error(i18n.t('orderDetails.somethingWentWrong'));
      }
    });
  };

  const deleteRow = (id: number) => {
    axiosInstance
      .post(ApiConstants.row.delete, { id })
      .then((response) => {
        if (response.status === 200) {
          toast.success(i18n.t('tableDetails.successfullyDeleted'));
          fetchRows();
          fetchRows();
          handleClick?.();
        } else {
          toast.error(i18n.t('orderDetails.somethingWentWrong'));
        }
      })
      .catch(() => {
        toast.error(i18n.t('orderDetails.categoryUsedInProductsCannotDelete'));
      });
  };

  const title = useMemo(() => header, [header]);

  return (
    <div className="rrWrap">
      {/* Header */}
      <div className="rrHeader">
        <h3>{title}</h3>
      </div>

      {isOrder ? (
        <div className="rrBody">{i18n.t('menu.order')}</div>
      ) : (
        <div className="rrBody">
          {/* Create */}
          <form onSubmit={handleSubmit(onSubmit)} className="rrCreate">
            <GeneralInput
              required
              label={i18n.t('generic.name')}
              placeholder={i18n.t('generic.name')}
              name="name"
              type="text"
              errors={errors}
              control={control}
            />
            <GeneralInput
              label={i18n.t('generic.code')}
              placeholder={i18n.t('generic.code')}
              name="code"
              type="text"
              errors={errors}
              control={control}
            />

            <button type="submit" className="ui-control ui-btn ui-btn--primary rrAddBtn">
              +
            </button>
          </form>

          {/* List */}
          <div className="rrList">
            {rows.map((item, index) => (
              <div key={item.id} className="rrRow bcCard">
                <GeneralInput
                  disabled={true}
                  label={i18n.t('generic.code')}
                  placeholder={i18n.t('generic.code')}
                  name={`code${index}`}
                  errors={errors}
                  type="text"
                  control={control}
                  dfvalue={item.code}
                />

                <GeneralInput
                  disabled={true}
                  label={i18n.t('generic.name')}
                  placeholder={i18n.t('generic.name')}
                  name={`name${index}`}
                  errors={errors}
                  type="text"
                  control={control}
                  dfvalue={item.name}
                />

                <button type="button" className="rrDeleteBtn" onClick={() => deleteRow(item.id)} title={i18n.t('generic.delete')}>
                  <DeleteForeverIcon className="rrDeleteIcon" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RowsManager;
